export default "__VITE_ASSET__gH4sDjDs__"